import React from "react";
import {Link} from 'react-router-dom';
import {SlideDown} from "react-slidedown";
import 'react-slidedown/lib/slidedown.css'
import {HEADER_MENU} from "../../default_informations/header_menu";

function HeaderMenu({showDeskMenu, showMobMenu}) {
    const headerMenu = HEADER_MENU;

    return (
        <div className="gg-header-nav col-auto">{
            showDeskMenu ? (
                <nav className="gg-header_menu">
                    <ul id="menu-top" className="menu">{
                        headerMenu.map(item => (
                            <li key={item.id} id={item.id} className={`menu-item ${item.id}`}>{
                                window.location.pathname === item.link ? (
                                    <span>{item.title}</span>
                                ) : (
                                    <Link to={item.link}>{item.title}</Link>
                                )
                            }</li>
                        ))
                    }</ul>
                </nav>
            ) : (
                <SlideDown>{
                    showMobMenu ? (
                        <nav className="gg-header_menu">
                            <ul id="menu-top" className="menu">{
                                headerMenu.map(item => (
                                    <li key={item.id} id={item.id} className={`menu-item ${item.id}`}>{
                                        window.location.pathname === item.link ? (
                                            <span>{item.title}</span>
                                        ) : (
                                            <Link to={item.link}>{item.title}</Link>
                                        )
                                    }</li>
                                ))
                            }</ul>
                        </nav>
                    ) : null
                }</SlideDown>
            )
        }</div>
    )
}

export default HeaderMenu;